import { createBrowserRouter } from "react-router-dom";
import RootLayout from "@shared/layouts/Layout.jsx";
import App from "@/App.jsx";
import ErrorPage from "./error-page.jsx";
import LoginPage from "@features/auth/pages/login-page";
import RegisterPage from "@features/auth/pages/register-page";
import ForgotPasswordPage from "@features/auth/pages/ForgotPasswordPage";
import ResetPasswordPage from "@features/auth/pages/ResetPasswordPage";
import { PrivateRoute } from "@shared/guards/PrivateRoute";

import TrackPackage from "@/features/packages/pages/track-package";

// Import route objects
import { productsRoutes } from "@/routes/productsRoutes";
import { pickupsRoutes } from "@/routes/pickupsRoutes";
import { packagesRoutes } from "@/routes/packagesRoutes";
import { settingsRoutes } from "@/routes/settingsRoutes";
import { invoicesRoutes } from "@/routes/invoicesRoutes";
import { ticketsRoutes } from "@/routes/ticketsRoutes";
import { clientSupportRoutes } from "@/routes/clientSupportRoutes";
import { adminRoutes } from "@/routes/adminRoutes";
import Dashboard from "@features/dashboard/pages/dashboard";
import InvoiceDetails from "@features/invoices/pages/InvoicesDetails";
import { usersRoutes } from "./usersRoutes.jsx";
import Account from "@/features/users/Account";
import SetupAccount from "@features/users/pages/setup-account";
import { returnVoucherRoutes } from "./ReturnVoucherRoutes.jsx";
import PendingBankingRequests from "@features/banking/pages/pending-requests";

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <PrivateRoute>
        <RootLayout>
          <App />
        </RootLayout>
      </PrivateRoute>
    ),
    errorElement: <ErrorPage />,

    children: [
      {
        path: "/",
        element: <Dashboard />,
      },
      {
        path: "/tracking",
        element: <TrackPackage />,
      },
      settingsRoutes,
      productsRoutes,
      pickupsRoutes,
      packagesRoutes,
      invoicesRoutes,
      usersRoutes,
      ticketsRoutes,
      returnVoucherRoutes,
      clientSupportRoutes,
      adminRoutes,
      { path: "/account", element: <Account /> },
      { path: "/setup-account", element: <SetupAccount /> },
      {
        path: "/banking/pending-requests",
        element: <PendingBankingRequests />,
      },
    ],
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/print/invoice/:id",
    element: <InvoiceDetails />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
]);
